import React from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import { track } from '@adc/analytics'
import { EnhancedDropdown } from '@adc/ui-adc'
import { search } from '@adc/blueprint'

const EXPERIMENT_FLAG_KEY = 'fe.resi.srp-sort-experiment-v1'

const SortDropdown = ({
  elmId,
  direction = 'right',
  onSelect,
  selectedValue = search.sorting.constants.WEB_SORT_TYPES.auctionStartDate,
  featureFlags = null,
  title,
  onOpen = noop,
  onClose = noop,
  selection = false,
  selectedDirection,
  ...rest
}) => {
  const onDropdownClick = value => {
    track('sort', { sortSelection: value })
    onSelect(value)
  }

  const experimentFlag = featureFlags?.[EXPERIMENT_FLAG_KEY]
  const inExperiment = experimentFlag === 'treatment'

  // MERCH-1036: hide Recommended unless user is in sort experiment (MERCH-1922)
  const sortOptions = search.sorting.constants.ARVSortOptionsOrder.filter(
    sortOption =>
      inExperiment ||
      sortOption.value !== search.sorting.constants.WEB_SORT_TYPES.recommended
  )

  const selectedOption =
    sortOptions.find(o => o.value === selectedValue) ||
    sortOptions.find(
      o => o.value === search.sorting.constants.WEB_SORT_TYPES.auctionStartDate
    )

  return (
    <EnhancedDropdown
      elmId={`${elmId}_sort_dropdown`}
      variant='enhanced'
      direction={direction}
      options={sortOptions}
      selectedValue={selectedValue}
      onSelect={onDropdownClick}
      onOpen={onOpen}
      onClose={onClose}
      icon={title}
      {...(selection
        ? { selection, text: selectedOption?.text, fluid: true }
        : {})}
      {...rest}
    />
  )
}

SortDropdown.propTypes = {
  elmId: PropTypes.string,
  direction: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  selectedValue: PropTypes.string,
  featureFlags: PropTypes.object,
  title: PropTypes.node,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  selection: PropTypes.bool,
  selectedDirection: PropTypes.string,
}

export default SortDropdown
